// Inside app/frontend/src/components/integrations/PersonalIntegrations.tsx
import { Box, Typography } from "@mui/material";
import IntegrationsManager from "./IntegrationsManager ";

const PersonalIntegrations = () => {
    return (
        <Box>
            <IntegrationsManager />
        </Box>
    );
};

export default PersonalIntegrations;